//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            routes: {
                general: [],
                days: {}
            }
        };
    },

    mounted () {
        this.$router.options.routes.forEach(route => {
            if (route && route.meta && route.meta.dayRoute) {
                let weekDay = route.name.substring(0, 4);

                if (this.routes.days && this.routes.days[weekDay] === undefined) {
                    this.routes.days[weekDay] = [];
                }

                this.routes.days[weekDay].push({
                    name: route.name,
                    path: route.path
                });
            } else {
                this.routes.general.push({
                    name: route.name,
                    path: route.path
                });
            }
        });
    },

    methods: {
        getLabel (key ) {
            let week = this.$lang.get('routelist.week') + key.split('')[1];
            let day = this.$lang.get('routelist.day') + key.split('')[3];

            return `<b>${week}, ${day}</b>`;
        }
    }
};
